import { type ContentObjectRedux } from 'models';
import { dispatch } from 'old/store';
import { useMutation } from 'query';
import { type ReplyDataObject } from 'models/service';
import { likeObject } from '../../services';

export const useLikeObjectMutation = () =>
  // TODO ideally instead of `id` real application object and remove `reduxItem`
  useMutation<unknown, { id: string; reduxItem: ContentObjectRedux | ReplyDataObject }>(
    async ({ id }) => likeObject(id),
    {
      async onSuccess(_, params) {
        await dispatch.feed.storeContentObjectLike({ object: params.reduxItem }); // TODO remove this from redux
      },
    },
  );
